"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappedAttributeSection = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var contentConstants_1 = __importDefault(require("../../../contentConstants"));
var common_1 = require("../../common");
var MappedAttributeSection = /** @class */ (function (_super) {
    __extends(MappedAttributeSection, _super);
    function MappedAttributeSection(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { selected: undefined, selectedAttributes: [] };
        _this.onSelect = _this.onSelect.bind(_this);
        return _this;
    }
    /*
        Note: because this component is used inside a modal we cannot rely on it receiving updates from the props
              an internal function sets the state when a new selection is made
    */
    MappedAttributeSection.prototype.componentDidMount = function () {
        this.setState({
            selectedAttributes: __spreadArray([], this.props.selectedAttributes, true),
            selected: this.props.selected,
        });
    };
    MappedAttributeSection.prototype.render = function () {
        var _a = this.props, validationResult = _a.validationResult, className = _a.className;
        var selected = this.state.selected;
        var attributes = this.getAttributesForSelector();
        var showError = (validationResult && !validationResult.isValid) || false;
        var messages = !validationResult ? '' : validationResult.errors || [];
        return (React.createElement(common_1.Section, { id: 'custom-question-mapped-attribute', className: className, sectionHeader: contentConstants_1.default.CUSTOM_DEMOGRAPHIC_QUESTION_MAPPED_ATTRIBUTE_HEADER },
            React.createElement(common_1.ErrorMessage, { message: messages, show: showError }),
            React.createElement(common_1.LabelAbove, { type: 'clickbox', textIsHtml: true, text: contentConstants_1.default.CUSTOM_DEMOGRAPHIC_QUESTION_MAPPED_ATTRIBUTE_MESSAGE }),
            React.createElement(aon_tws_common_ui_1.Select, { items: attributes, size: 'md', selectSize: 'lg', dropdownSize: 'lg', onApply: this.onSelect, displayText: contentConstants_1.default.MAPPED_ATTRIBUTE_SELECTOR_TEXT, disabled: attributes.length === 0, selectedValue: selected, error: showError, showApplyButton: false }),
            React.createElement(common_1.ClearDiv, { clearHeight: '50px' })));
    };
    MappedAttributeSection.prototype.getAttributesForSelector = function () {
        var attributes = this.props.attributes;
        var selectedAttributes = this.state.selectedAttributes;
        return attributes.map(function (attr, index) { return ({
            name: attr.columnName,
            displayText: attr.displayName,
            displayOrder: index,
            disabled: selectedAttributes.indexOf(attr.columnName) > -1,
        }); });
    };
    MappedAttributeSection.prototype.onSelect = function (value) {
        if (value !== undefined) {
            var attribute = this.props.attributes.find(function (attr) { return attr.columnName === value; }) || {
                columnName: value,
                attributeName: undefined,
                displayName: '',
            };
            this.props.onSelect(value, attribute);
            this.updateSelectedAttributes(this.state.selected, value);
        }
    };
    MappedAttributeSection.prototype.updateSelectedAttributes = function (original, next) {
        if (next !== undefined) {
            var selectedAttributes = this.state.selectedAttributes.filter(function (attr) { return attr !== original; }).concat([next]);
            this.setState({
                selectedAttributes: selectedAttributes,
                selected: next,
            });
        }
    };
    return MappedAttributeSection;
}(React.Component));
exports.MappedAttributeSection = MappedAttributeSection;
